import { WorkspaceMemberRoleDisplayName, WorkspaceMemberType, type WorkspaceUserRole } from '@air/api/types';

import { getLeastPermissiveRole } from '~/utils/PermissionsUtils';

export {
  MAX_INVITE_EMAILS as ONBOARDING_INVITE_MAX_EMAILS,
  type ParseInviteEmailsResult as ParseOnboardingInviteEmailsResult,
  parseInviteEmails as parseOnboardingInviteEmails,
} from '~/utils/InviteEmailUtils';

const TOTAL_FORM_STEPS_FIRST_WORKSPACE = 4;
const TOTAL_FORM_STEPS_NON_FIRST_WORKSPACE = 2;
const TOTAL_FORM_STEPS_ONBOARDING_INVITE_STEP = 1;

export const DEFAULT_ONBOARDING_INVITE_ROLE = WorkspaceMemberRoleDisplayName.Editor;

export type OnboardingInviteRoleDisplayName =
  | WorkspaceMemberRoleDisplayName.Admin
  | WorkspaceMemberRoleDisplayName.Editor;

export type OnboardingInviteRoleOption = {
  description: string;
  displayName: OnboardingInviteRoleDisplayName;
};

export const ONBOARDING_INVITE_ROLE_OPTIONS: OnboardingInviteRoleOption[] = [
  {
    description: 'Can edit workspace settings, including billing and plan info',
    displayName: WorkspaceMemberRoleDisplayName.Admin,
  },
  {
    description: 'Full permissions on all content, but cannot edit workspace settings',
    displayName: WorkspaceMemberRoleDisplayName.Editor,
  },
];

export const getTotalFormSteps = (isFirstWorkspace: boolean, includeTeamInviteStep = false) => {
  const baseTotalSteps = isFirstWorkspace ? TOTAL_FORM_STEPS_FIRST_WORKSPACE : TOTAL_FORM_STEPS_NON_FIRST_WORKSPACE;

  return isFirstWorkspace && includeTeamInviteStep
    ? baseTotalSteps + TOTAL_FORM_STEPS_ONBOARDING_INVITE_STEP
    : baseTotalSteps;
};

export const getOnboardingInviteRole = ({
  preferredRoleDisplayName,
  roles,
}: {
  preferredRoleDisplayName: string;
  roles: WorkspaceUserRole[];
}) => {
  const enabledMemberRoles = roles.filter((role) => role.type === WorkspaceMemberType.member && role.enabled !== false);

  return (
    enabledMemberRoles.find((role) => role.displayName === preferredRoleDisplayName) ||
    enabledMemberRoles.find((role) => role.displayName === DEFAULT_ONBOARDING_INVITE_ROLE) ||
    (enabledMemberRoles.length ? getLeastPermissiveRole(enabledMemberRoles) : undefined)
  );
};
